"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClipartPainter = void 0;
var PathBasedPainter_1 = require("../../PathBasedPainter");
var round_1 = require("../../../util/round");
/**
 * Implements drawing-related operations for clipart. This is a very minimal image type,
 * suitable for clipart and other "stretchable" kinds of images/illustrations. For photo
 * editing applications, refer to {@link Photo}.
 */
var ClipartPainter = /** @class */ (function (_super) {
    __extends(ClipartPainter, _super);
    /**
     * @param loadImage An image loading function for the current environment.
     * @param getLoadingPlaceholder Provides an image to display while `clipart.url` is being loaded.
     */
    function ClipartPainter(loadImage, getLoadingPlaceholder) {
        var _this = _super.call(this, "clipart") || this;
        _this.loadImage = loadImage;
        _this.getLoadingPlaceholder = getLoadingPlaceholder;
        _this.baseWidthOf = function (object) { return object.width; };
        _this.baseHeightOf = function (object) { return object.height; };
        return _this;
    }
    ClipartPainter.prototype.loadResources = function (store, object) {
        var _this = this;
        store.load("image", function () { return _this.loadImage(object.url); }, { hash: object.url });
    };
    ClipartPainter.prototype.tracePath = function (ctx, store, object) {
        ctx.rect(0, 0, object.width, object.height);
    };
    /**
     * Paints the image, or a placeholder if the image is loading or failed to load.
     */
    ClipartPainter.prototype.paintFill = function (store, object) {
        var ctx = store.layers.result.ctx;
        var image = store.require("image");
        image.status === "loaded"
            ? this._paintImage(ctx, image.result, object)
            : this._paintImage(ctx, this.getLoadingPlaceholder(object), object);
    };
    /**
     * Paints an image stretched to the object's dimensions.
     */
    ClipartPainter.prototype._paintImage = function (ctx, image, object) {
        ctx.save();
        if (!object.stroke) {
            this.applyShadowSettings(ctx, object);
        }
        ctx.scale(object.scaleX, object.scaleY);
        ctx.scale(object.flipX ? -1 : 1, object.flipY ? -1 : 1);
        var x = object.flipX ? -object.width : 0;
        var y = object.flipY ? -object.height : 0;
        ctx.drawImage(image, round_1.round(object, x), round_1.round(object, y), round_1.round(object, object.width), round_1.round(object, object.height));
        ctx.restore();
    };
    ClipartPainter.prototype.shouldRepaint = function (previousData, newData) {
        return _super.prototype.shouldRepaint.call(this, previousData, newData)
            || newData.url !== previousData.url
            || newData.flipX !== previousData.flipX
            || newData.flipY !== previousData.flipY;
    };
    return ClipartPainter;
}(PathBasedPainter_1.PathBasedPainter));
exports.ClipartPainter = ClipartPainter;
//# sourceMappingURL=ClipartPainter.js.map